import React, { useEffect, useState } from 'react'
import Modal, { ModalBody, ModalFooter, ModalHeader } from './Modal'
import { HcContext } from '../../types/hccontext';
import GetHtmlStrLocalized from '../../datas/GetHtmlStrLocalized';
import { createErrorModalContent } from '../../props/ModalContentProps';
import InputWithStyle from '../banner/InputWithStyle';


interface YesNoModalProps {
    language: string;
    show: boolean;
    setShow: React.Dispatch<React.SetStateAction<boolean>>;
    hcContext: HcContext;
    setProcessingModifications: (v: boolean) => any;
    onModification?: () => any;
    tag?: string;
}

export class TagModificationPostContentType {
    language: string;
    userKey: string;
    id: string;
    newId: string;

    constructor(
        language: string,
        userKey: string,
        id: string,
        newId: string) {
        this.language = language;
        this.userKey = userKey;
        this.id = id;
        this.newId = newId;
    }
}

function AddOrModifyTagModal({ language, show, setShow, hcContext, setProcessingModifications, onModification, tag }: Readonly<YesNoModalProps>) {

    const [newId, setNewId] = useState<string>("")

    useEffect(() => {
        if (show)
            setNewId(tag !== undefined ? tag : "")
    }, [show]);

    function sendTagModification(inputText: string | undefined) {
        if (!hcContext.userToken || !inputText)
            return
        setProcessingModifications(true)
        hcContext.setBlackCoverOfContent(true)
        const postContent = new TagModificationPostContentType(language, hcContext.userToken,
            tag ?? "", inputText)
        fetch(hcContext.backendUrl + "/modify_tag", {
            method: 'POST',
            body: JSON.stringify(postContent),
            headers: { 'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8' }
        })
            .then(res => res.json())
            .then(jsonData => {
                setProcessingModifications(false)
                hcContext.setBlackCoverOfContent(false)
                if (jsonData.errorMessage) {
                    hcContext.setError(createErrorModalContent(language, jsonData.errorMessage))
                } else if (jsonData.id === inputText) {
                    if (onModification !== undefined)
                        onModification()
                }
                setShow(false)
            })
            .catch(rejected => {
                setProcessingModifications(false)
                hcContext.setBlackCoverOfContent(false)
                setShow(false)
                hcContext.setError(createErrorModalContent(language, rejected.message))
            });
    }

    return (
        <Modal
            language={language}
            show={show}
            setShow={setShow}
            isDarkTheme={hcContext.isDarkTheme}
        >
            <ModalHeader>
                <h3><GetHtmlStrLocalized language={language} textId={tag === undefined ? "addATag" : "modifyATag"} /></h3>
            </ModalHeader>
            <ModalBody>
                <InputWithStyle value={newId} onValidation={sendTagModification}
                    onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
                        setNewId(event.target.value)
                    }} language={language} hcContext={hcContext} height={hcContext.defaultLineEditHeight()} autoFocus={true} />
            </ModalBody>
            <br />
            <ModalFooter>
                {
                    newId !== "" &&
                    <button onClick={() => {
                        sendTagModification(newId)
                    }}>
                        <GetHtmlStrLocalized language={language} textId="validate" />
                    </button>
                }
            </ModalFooter>
        </Modal>
    );
}

export default AddOrModifyTagModal;